import React, { memo, useMemo, useCallback } from "react"

import { useCart } from "../../../hooks/useCart"
import { useShopify } from "../../../hooks/useShopify"

export const withCartItem = Component =>
  memo(({ name = "CartItem", item }: any) => {
    const { loading: cartLoading, removeFromCart, updateQuantity } = useCart()
    const { imageNormaliser } = useShopify()

    const handleQuantity = useCallback(quantity => updateQuantity(item?.variant?.id, quantity), [item?.variant?.id, updateQuantity])
    const handleRemove = useCallback(() => removeFromCart(item?.variant?.id), [item?.variant?.id, removeFromCart])
    const image = imageNormaliser(item?.variant?.image, 250)

    Component.displayName = name
    return useMemo(() => <Component item={item} loading={cartLoading} handleQuantity={handleQuantity} handleRemove={handleRemove} image={image} />, [
      cartLoading,
      handleQuantity,
      handleRemove,
      image,
      item,
    ])
  })
